import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "./api";

const SiteContext = createContext({ content: null, tours: [], loading: true, refresh: () => {} });

export const SiteProvider = ({ children }) => {
  const [content, setContent] = useState(null);
  const [tours, setTours] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    try {
      const [c, t] = await Promise.all([api.get("/content"), api.get("/tours")]);
      setContent(c.data);
      setTours(t.data);
    } catch (e) {
      console.error("Failed to load site data", e);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  return (
    <SiteContext.Provider value={{ content, tours, loading, refresh: load }}>
      {children}
    </SiteContext.Provider>
  );
};

export const useSite = () => useContext(SiteContext);
